// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  StudentBadgeRepresentationBaseApiListResult,
  StudentCertificateRepresentationBaseApiListResult,
} from '../models/index'
import {
  StudentBadgeRepresentationBaseApiListResultFromJSON,
  StudentBadgeRepresentationBaseApiListResultToJSON,
  StudentCertificateRepresentationBaseApiListResultFromJSON,
  StudentCertificateRepresentationBaseApiListResultToJSON,
} from '../models/index'

export interface ApiV1AwardsStudentIdBadgesGetRequest {
  studentId: string
  skip?: number
  take?: number
  fromDate?: Date
}

export interface ApiV1AwardsStudentIdCertificatesGetRequest {
  studentId: string
  skip?: number
  take?: number
  fromDate?: Date
}

/**
 *
 */
export class AwardsApi extends runtime.BaseAPI {
  /**
   * Returns paginated student badges (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement) (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement)
   */
  async apiV1AwardsStudentIdBadgesGetRaw(
    requestParameters: ApiV1AwardsStudentIdBadgesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<StudentBadgeRepresentationBaseApiListResult>> {
    if (
      requestParameters.studentId === null ||
      requestParameters.studentId === undefined
    ) {
      throw new runtime.RequiredError(
        'studentId',
        'Required parameter requestParameters.studentId was null or undefined when calling apiV1AwardsStudentIdBadgesGet.',
      )
    }

    const queryParameters: any = {}

    if (requestParameters.skip !== undefined) {
      queryParameters['skip'] = requestParameters.skip
    }

    if (requestParameters.take !== undefined) {
      queryParameters['take'] = requestParameters.take
    }

    if (requestParameters.fromDate !== undefined) {
      queryParameters['fromDate'] = (
        requestParameters.fromDate as any
      ).toISOString()
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/awards/{studentId}/badges`.replace(
          `{${'studentId'}}`,
          encodeURIComponent(String(requestParameters.studentId)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StudentBadgeRepresentationBaseApiListResultFromJSON(jsonValue),
    )
  }

  /**
   * Returns paginated student badges (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement) (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement)
   */
  async apiV1AwardsStudentIdBadgesGet(
    requestParameters: ApiV1AwardsStudentIdBadgesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StudentBadgeRepresentationBaseApiListResult> {
    const response = await this.apiV1AwardsStudentIdBadgesGetRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   * Returns paginated student certificates (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement) (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement)
   */
  async apiV1AwardsStudentIdCertificatesGetRaw(
    requestParameters: ApiV1AwardsStudentIdCertificatesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<
    runtime.ApiResponse<StudentCertificateRepresentationBaseApiListResult>
  > {
    if (
      requestParameters.studentId === null ||
      requestParameters.studentId === undefined
    ) {
      throw new runtime.RequiredError(
        'studentId',
        'Required parameter requestParameters.studentId was null or undefined when calling apiV1AwardsStudentIdCertificatesGet.',
      )
    }

    const queryParameters: any = {}

    if (requestParameters.skip !== undefined) {
      queryParameters['skip'] = requestParameters.skip
    }

    if (requestParameters.take !== undefined) {
      queryParameters['take'] = requestParameters.take
    }

    if (requestParameters.fromDate !== undefined) {
      queryParameters['fromDate'] = (
        requestParameters.fromDate as any
      ).toISOString()
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        this.configuration.apiKey('Authorization') // oauth2 authentication
    }

    const response = await this.request(
      {
        path: `/api/v1/awards/{studentId}/certificates`.replace(
          `{${'studentId'}}`,
          encodeURIComponent(String(requestParameters.studentId)),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StudentCertificateRepresentationBaseApiListResultFromJSON(jsonValue),
    )
  }

  /**
   * Returns paginated student certificates (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement) (Auth policies: StudentResourceRequirement, StudentTokenRoleRequirement)
   */
  async apiV1AwardsStudentIdCertificatesGet(
    requestParameters: ApiV1AwardsStudentIdCertificatesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<StudentCertificateRepresentationBaseApiListResult> {
    const response = await this.apiV1AwardsStudentIdCertificatesGetRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }
}
